import React from "react";
import ReactMarkdown from "markdown-to-jsx";

import styles from "./styles.scss";

// Report question text columns (helper, footer, not_applicable_desc, ...)
// are nullable. markdown-to-jsx calls `.replace` on its input unguarded, so a
// null child crashes the whole report step. Render nothing for missing text.
export function Markdown({ children }: { children: string | null | undefined }) {
  if (children == null || children === "") {
    return null;
  }

  return (
    <div className={styles.markdownWrapper}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
